import React, { useCallback } from "react";
import { Typography, Chip, Stack } from "@mui/material";
import { PlayArrow as DemoIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SchoolStatusTable from "../components/schools/SchoolStatusTable";
import apiService from "../services/apiService";
import { crmColors } from "../theme/colors";

//Created By Cursor — Demo page shows In Demo + Demo expired
const demoStatusChip = (row) => {
  const expired =
    Boolean(row.demo_expired) ||
    /expired/i.test(String(row.demo_status || row.demo_label || ""));
  const label =
    row.demo_status ||
    row.demo_label ||
    row.Demo_Status ||
    (expired ? "Demo expired" : "In Demo");
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        fontWeight: 800,
        height: 24,
        borderRadius: "8px",
        color: "#fff",
        bgcolor: expired ? crmColors.error.main : crmColors.info.main,
      }}
    />
  );
};

const DemoSchools = () => {
  const navigate = useNavigate();

  const fetchRows = useCallback(
    () => apiService.getSchoolsInDemo({ demo_days: "ALL", limit: 500, offset: 0, order: "DESC" }),
    []
  );

  return (
    <SchoolStatusTable
      title="Demo Schools"
      subtitle="Schools in demo period or with demo expired"
      breadcrumbLabel="Demo Schools"
      breadcrumbIcon={<DemoIcon sx={{ color: "#ffffff", fontSize: 18 }} />}
      fetchRows={fetchRows}
      onRowClick={(row) => {
        const code = row.school_code;
        if (code) navigate(`/schools/detail/${encodeURIComponent(code)}`);
      }}
      columns={[
        {
          id: "name",
          label: "School",
          render: (row) => (
            <Stack spacing={0.15}>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                {row.school_name || row.School_Name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.school_code || "—"}
              </Typography>
            </Stack>
          ),
        },
        {
          id: "contact",
          label: "Contact",
          render: (row) => (
            <Stack spacing={0.15}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {row.admin_name || row.Admin_Name || "—"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {row.admin_phone || row.Admin_Phone || "—"}
              </Typography>
            </Stack>
          ),
        },
        {
          id: "location",
          label: "Location",
          render: (row) =>
            [row.state, row.country].filter(Boolean).join(", ") || "—",
        },
        {
          id: "demo",
          label: "Demo Status",
          render: (row) => demoStatusChip(row),
        },
        {
          id: "students",
          label: "Students",
          align: "right",
          render: (row) =>
            Number(row.total_student || row.total_students || 0).toLocaleString(),
        },
      ]}
      searchFields={(row) => [
        row.school_name,
        row.School_Name,
        row.school_code,
        row.admin_name,
        row.Admin_Name,
        row.admin_phone,
        row.state,
        row.country,
        row.demo_status,
        row.demo_label,
      ]}
    />
  );
};

export default DemoSchools;
